export interface IBetBuilderPickState {
    isSelected: boolean;
    isLocked: boolean;
    stake: number | null;
    rewardTokenId: string | null;
    actualStake: string | null;
}

export interface IBetBuilderBetState {
    picks: { [pickId: string]: IBetBuilderPickState };
}

export const defaultBetBuilderBetState: IBetBuilderBetState = Object.freeze({
    picks: {},
});
